<template>
  <el-dialog
    title="添加账号"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="30%">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm">
        <el-form-item prop="platform" v-if="platformConf.length">
          <el-select
            v-model="ruleForm.platform"
            @change="(item) => {
              setPlatform(item)
            }"
            placeholder="请选择主体"
            style="width: 100%;">
            <el-option
              v-for="item in platformConf"
              :key="item.value"
              :label="item.label"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="username">
          <el-input
            v-model="ruleForm.username"
            autocomplete="off"
            placeholder="请输入帐号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            placeholder="请输入密码"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            style="width: 100%"
            @click="submitForm('ruleForm')"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import fetch from "@/assets/js/axios.js"; //导入axios.js文件
import { platformConf } from '@/assets/js/common'

export default {
  name: 'LoginDialog',
  data() {
    var validateUserName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("帐号不能为空"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };

    return {
      platformConf,
      isMobile: false,
      ruleForm: {
        username: "",
        password: "",
        platform: null
      },
      rules: {
        platform: [{ required: true, message: '请选择主体', trigger: "change" }],
        username: [{ validator: validateUserName, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
      },
    };
  },
  props: {
    dialogVisible: Boolean
  },
  computed: {
    ...mapState(["companiesList"]),
  },
  watch: {
    companiesList: {
      handler (val) {
        this.platformConf = platformConf.filter(item => val.includes(item.value))
        if (!val.length) this.selectMajorPlatform()
      }
    }
  },
  mounted() {
    this.ruleForm.username = localStorage.getItem("username");
    this.ruleForm.password = localStorage.getItem("password");
    const PLATFORM_USER = localStorage.getItem("PLATFORM_USER") && JSON.parse(localStorage.getItem("PLATFORM_USER"))
    if (PLATFORM_USER) this.setCompaniesList(PLATFORM_USER.companies || '')
  },
  methods: {
    ...mapMutations(["setPlatform", "setPlatformList", "setCompaniesList"]),
    handleClose () {
      this.$emit('close')
    },
    selectMajorPlatform () {
      const platform = platformConf.find(item => item.value === (process.env.VUE_APP_ENV || 'test'))
      this.ruleForm.platform = platform
      this.setPlatform(platform)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 登录
          fetch({
            url: "/admin/authorizations/login",
            method: "POST",
            data: {
              username: this.ruleForm.username,
              password: this.ruleForm.password,
            },
          })
            .then((res) => {
              if (!res.data.status) {
                this.$message.error(res.data.message);
              } else {
                const { access_token, expired_at } = res.data.data
                sessionStorage.setItem(
                  "access_token",
                  access_token
                );
                sessionStorage.setItem(
                  "access_token_expired_at",
                  expired_at
                );
                localStorage.setItem("username", this.ruleForm.username);
                localStorage.setItem("password", this.ruleForm.password);
                fetch({
                  url: "/admin/admin/me",
                  method: "GET",
                  data: {},
                })
                  .then(async (res) => {
                    if (res.data.status) {
                      const loginData = res.data.data
                      const user = {
                        ...this.ruleForm.platform,
                        ...loginData,
                        access_token,
                        access_token_expired_at: expired_at,
                        companies: loginData.companies || this.ruleForm.platform.value
                      }
                      await this.$bus.$emit('updateCurrentUser')
                      await this.setPlatformList(user)
                      await this.$bus.$emit('getMagic')
                      this.$bus.$emit('updateCurrentTab')
                      this.ruleForm.platform = null
                      this.$emit('close')
                    } else {
                      this.$message.error(res.data.message);
                    }
                  })
                  .catch((error) => {
                    this.$message.error(error);
                  });
              }
              // console.log(res)
            })
            .catch((error) => {
              // this.$message.error(error)
            });
        } else {
          return false;
        }
      });
    },
  },
}
</script>

<style lang="less" scoped>

</style>
